<template>
  <div class="gpsr-template-view">
    <Spin v-if="pageLoading" fix></Spin>
    <div class="item-warning">提示：GPSR填写模板区分事业部单独使用，登录的用户可使用所在事业部的GPSR填写模板</div>
    <div class="details-item item-width-auto mt15">
      <label class="details-label">事业部：</label>
      <div class="details-value">{{ businessDeptNameList.join('，') }}</div>
    </div>
    <div class="sticky-head-block">
      <Tabs v-model="tabValue" @on-click="tabSwitch">
        <TabPane v-for="(tab, tIndex) in tabDataList" :label="tab.label" :name="tab.key" :key="`${tab.key}-${tIndex}`" />
      </Tabs>
      <div class="content-item-head mt10">
        <Button v-if="activeTabInfo" type="primary" @click="openAddEditTemplate(null, activeTabInfo.key)">新增</Button>
      </div>
    </div>
    <div class="tab-content">
      <template v-for="(tab, index) in tabDataList">
        <div v-if="tabPageConfig[tab.key].visible" v-show="tab.key == tabValue" :key="`view-${tab.key}-${index}`" class="content-item">
          <Table
            class="mt10"
            highlight-row
            :max-height="490"
            :loading="tabPageConfig[tab.key].loading"
            border
            :columns="tabPageConfig[tab.key].columns"
            :data="tabPageConfig[tab.key].tableData"
          ></Table>
          <Page
            class="mt10"
            :total="tabPageConfig[tab.key].total"
            @on-change="pageNumChange($event, tab.key)"
            show-total
            :page-size="tabPageConfig[tab.key].pageSize"
            show-elevator
            :current="tabPageConfig[tab.key].pageNum"
            show-sizer
            @on-page-size-change="pageSizeChange($event, tab.key)"
            placement="top"
            :page-size-opts="pageSizeOption"
          />
        </div>
      </template>
    </div>
    <Modal v-model="itemModalVisible" :title="itemModalData.title" :mask-closable="false" :width="itemModalData.width">
      <gpsrTemplateEdit
        ref="gpsrModalEditRef"
        v-if="itemModalVisible"
        :module-data="itemModalData"
      />
      <div slot="footer">
        <Button type="primary" @click="itemModalConfirm" :disabled="itemModalLoading">确定</Button>
        <Button @click="itemModalVisible = false">取消</Button>
      </div>
    </Modal>
  </div>
</template>
<script>
import gpsrTemplateEdit from './gpsrTemplateEdit';
import api from '@/api/api';

export default {
  name: "gpsrTemplateView",
  components: {
    gpsrTemplateEdit
  },
  props: {
    moduleData: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      pageLoading: true,
      itemModalVisible: false,
      itemModalLoading: false,
      itemModalData: {},
      tabPageConfig: {},
      pageSizeOption: [10, 20, 50, 100],
      activeTabInfo: {},
      tabValue: '',
      publicCol: [
        {
          title: '可使用事业部',
          key: 'businessDeptId',
          align: 'center',
          minWidth: 120,
          render: (h, { row }) => {
            if (this.$common.isEmpty(row.businessDeptId)) return h('span', {}, '');
            const deptInfo = this.allBusinessDept.find(item => item.id == row.businessDeptId);
            if (this.$common.isEmpty(deptInfo)) return h('span', {}, row.businessDeptId);
            return h('span', {}, deptInfo.name);
          }
        },
        {
          title: '创建人',
          key: 'createBy',
          align: 'center',
          minWidth: 130,
          render: (h, { row }) => {
            if (this.$common.isEmpty(row.createBy)) return h('span', {}, '');
            const userInfo = this.allUserData[row.createBy];
            if (this.$common.isEmpty(userInfo)) return h('span', {}, row.createBy);
            return h('span', {}, userInfo.userName);
          }
        },
        { title: '创建时间', key: 'createdTime', align: 'center', minWidth: 150 },
        {
          title: '操作',
          key: "operation",
          align: 'center',
          fixed: 'right',
          width: 110,
          render: (h, { row }) => {
            let operItem = [];
            operItem.push(h('Button', {
              props: {
                type: 'primary',
                size: 'small'
              },
              on: {
                click: () => {
                  this.openAddEditTemplate(row, this.activeTabInfo.key);
                }
              }
            }, '编辑'));
            if (this.deleteTemplate) {
              operItem.push(h('Button', {
                class: 'ml5',
                props: {
                  type: 'error',
                  size: 'small'
                },
                on: {
                  click: () => {
                    this.deleteGpsrTemplate(row, this.activeTabInfo.key);
                  }
                }
              }, '删除'));
            }

            return operItem;
          }
        },
      ],
      tabDataList: [
        {
          label: '生产商信息',
          key: 'manufacturer',
          warTips: '生产商信息区分事业部单独使用，登录的用户可使用所在事业部的生产商信息',
          listApi: api.queryGpsrManufacturer,
          saveApi: api.gpsrManufacturerInfo,
          deleteApi: api.gpsrManuDelete,
          replaceId: 'manufacturerInfoId',
          replaceName: 'name',
          width: '940px',
          columns: [
            {
              title: '名称',
              key: 'name',
              align: 'center',
              minWidth: 150,
              render: (h, { row }) => {
                return h('div', {
                  style: {
                    'display': 'inline-block',
                    'text-align': 'left',
                    'white-space': 'pre-wrap',
                  }
                }, row.name || '');
              }
            },
            {
              title: 'Manufacturer',
              key: 'manufacturer',
              align: 'center',
              minWidth: 150,
              render: (h, { row }) => {
                return h('div', {
                  style: {
                    'display': 'inline-block',
                    'text-align': 'left',
                    'white-space': 'pre-wrap',
                  }
                }, row.manufacturer || '');
              }
            },
            {
              title: 'Address',
              key: 'address',
              align: 'center',
              minWidth: 200,
              render: (h, { row }) => {
                return h('div', {
                  style: {
                    'display': 'inline-block',
                    'text-align': 'left',
                    'white-space': 'pre-wrap',
                  }
                }, row.address || '');
              }
            },
            {
              title: 'e-mail',
              key: 'eMail',
              align: 'center',
              minWidth: 120,
              render: (h, { row }) => {
                return h('div', {
                  style: {
                    'display': 'inline-block',
                    'text-align': 'left',
                    'white-space': 'pre-wrap',
                  }
                }, row.eMail || '');
              }
            },
          ]
        },
        {
          label: '欧代信息',
          key: 'euCompany',
          warTips: '欧代信息区分事业部单独使用，登录的用户可使用所在事业部的欧代信息',
          listApi: api.queryGpsrEuropeAgent,
          saveApi: api.gpsrEuropeAgentInfo,
          deleteApi: api.gpsrEuropeDelete,
          replaceId: 'europeAgentInfoId',
          replaceName: 'europeAgentName',
          width: '940px',
          columns: [
            {
              title: '名称',
              key: 'europeAgentName',
              align: 'center',
              minWidth: 150,
              render: (h, { row }) => {
                return h('div', {
                  style: {
                    'display': 'inline-block',
                    'text-align': 'left',
                    'white-space': 'pre-wrap',
                  }
                }, row.europeAgentName || '');
              }
            },
            {
              title: 'Name',
              key: 'name',
              align: 'center',
              minWidth: 150,
              render: (h, { row }) => {
                return h('div', {
                  style: {
                    'display': 'inline-block',
                    'text-align': 'left',
                    'white-space': 'pre-wrap',
                  }
                }, row.name || '');
              }
            },
            {
              title: 'Address',
              key: 'address',
              align: 'center',
              minWidth: 200,
              render: (h, { row }) => {
                return h('div', {
                  style: {
                    'display': 'inline-block',
                    'text-align': 'left',
                    'white-space': 'pre-wrap',
                  }
                }, row.address || '');
              }
            },
            {
              title: 'e-mail',
              key: 'eMail',
              align: 'center',
              minWidth: 120,
              render: (h, { row }) => {
                return h('div', {
                  style: {
                    'display': 'inline-block',
                    'text-align': 'left',
                    'white-space': 'pre-wrap',
                  }
                }, row.eMail || '');
              }
            },
          ]
        },
        {
          label: '英代信息',
          key: 'ukCompany',
          warTips: '英代信息区分事业部单独使用，登录的用户可使用所在事业部的英代信息',
          listApi: api.queryGpsrBritainAgent,
          saveApi: api.gpsrBritainAgentInfo,
          deleteApi: api.gpsrBritainDelete,
          replaceId: 'britainAgentInfoId',
          replaceName: 'britainAgentName',
          width: '940px',
          columns: [
            {
              title: '名称',
              key: 'britainAgentName',
              align: 'center',
              minWidth: 150,
              render: (h, { row }) => {
                return h('div', {
                  style: {
                    'display': 'inline-block',
                    'text-align': 'left',
                    'white-space': 'pre-wrap',
                  }
                }, row.britainAgentName || '');
              }
            },
            {
              title: 'Name',
              key: 'name',
              align: 'center',
              minWidth: 150,
              render: (h, { row }) => {
                return h('div', {
                  style: {
                    'display': 'inline-block',
                    'text-align': 'left',
                    'white-space': 'pre-wrap',
                  }
                }, row.name || '');
              }
            },
            {
              title: 'Address',
              key: 'address',
              align: 'center',
              minWidth: 200,
              render: (h, { row }) => {
                return h('div', {
                  style: {
                    'display': 'inline-block',
                    'text-align': 'left',
                    'white-space': 'pre-wrap',
                  }
                }, row.address || '');
              }
            },
            {
              title: 'e-mail',
              key: 'eMail',
              align: 'center',
              minWidth: 120,
              render: (h, { row }) => {
                return h('div', {
                  style: {
                    'display': 'inline-block',
                    'text-align': 'left',
                    'white-space': 'pre-wrap',
                  }
                }, row.eMail || '');
              }
            },
          ]
        },
        {
          label: '安全警告信息',
          key: 'warning',
          warTips: '安全警告信息区分事业部单独使用，登录的用户可使用所在事业部的安全警告信息',
          listApi: api.queryGpsrSecurityWarning,
          saveApi: api.gpsrSecurityWarningInfo,
          deleteApi: api.gpsrWarningDelete,
          replaceId: 'securityWarningInfoId',
          replaceName: 'name',
          width: '940px',
          columns: [
            { title: '名称',
              key: 'name',
              align: 'center',
              minWidth: 150,
              render: (h, { row }) => {
                return h('div', {
                  style: {
                    'display': 'inline-block',
                    'text-align': 'left',
                    'white-space': 'pre-wrap',
                  }
                }, row.name || '');
              }
            },
            {
              title: 'WARNING',
              key: 'warning',
              align: 'center',
              minWidth: 200,
              render: (h, { row }) => {
                return h('div', {
                  style: {
                    'display': 'inline-block',
                    'text-align': 'left',
                    'white-space': 'pre-wrap',
                  }
                }, row.warning || '');
              }
            },
          ]
        },
        {
          label: '安全/环保/认证标识',
          key: 'safetyCertificate',
          warTips: '安全/环保/认证标识区分事业部单独使用，登录的用户可使用所在事业部的安全/环保/认证标识',
          listApi: api.queryGpsrIdentification,
          saveApi: api.gpsrIdentificationInfo,
          deleteApi: api.gpsrIdentDelete,
          replaceId: 'identificationInfoId',
          replaceName: 'name',
          width: '1200px',
          columns: [
            {
              title: '名称',
              key: 'name',
              align: 'center',
              minWidth: 150,
              render: (h, { row }) => {
                return h('div', {
                  style: {
                    'display': 'inline-block',
                    'text-align': 'left',
                    'white-space': 'pre-wrap',
                  }
                }, row.name || '');
              }
            },
            {
              title: '安全/环保/认证标识',
              key: 'identificationType',
              align: 'center',
              minWidth: 400,
              render: (h, { row }) => {
                if (this.$common.isEmpty(row.identificationType)) return h('div', {}, '');
                const typeList = row.identificationType.split(',');
                let imgList = [];
                this.iconDataList.forEach(item => {
                  if (typeList.includes(item.identificationType)) {
                    imgList.push(h('img', {
                      attrs: {
                        src: item.path,
                        title: item.name,
                        alt: item.name,
                      },
                      style: {
                        'display': 'inline-block',
                        'padding': '5px',
                        'max-height': '60px',
                        'border': '1px solid #ccc',
                        'margin-right': '5px',
                        'margin-bottom': '5px',
                      }
                    }));
                  }
                });
                return h('div', {
                  style: {
                    'margin-top': '5px',
                    'font-size': '0px',
                  }
                }, imgList);
              }
            },
          ]
        }
      ],
    };
  },
  watch: {},
  computed: {
    // 权限
    permission () {
      if (this.$common.isEmpty(this.moduleData) || this.$common.isEmpty(this.moduleData.permission)) return {};
      return this.moduleData.permission;
    },
    // 获取所有事业部
    allBusinessDept() {
      return this.$store.getters.getBusinessDeptList || [];
    },
    // 可查看(有权限)的事业部ID
    businessDeptIdList () {
      if (!this.$store.getters['authUserInfo'] || !this.$store.getters['authUserInfo'].securityUser) return [];
      if (this.$common.isEmpty(this.$store.getters['authUserInfo'].securityUser.businessDeptIds)) return [];
      return this.$store.getters['authUserInfo'].securityUser.businessDeptIds.split(',');
    },
    // 可查看(有权限)的事业部信息
    businessDeptInfo () {
      if (this.$common.isEmpty(this.allBusinessDept) || this.$common.isEmpty(this.businessDeptIdList)) return [];
      const filterList = this.allBusinessDept.filter(item => this.businessDeptIdList.includes((item.id).toString()));
      return filterList;
    },
    // 可查看(有权限)的事业部名称
    businessDeptNameList () {
      if (this.$common.isEmpty(this.businessDeptInfo)) return [];
      return this.businessDeptInfo.map(m => m.name);
    },
    // 所有用户
    allUserData () {
      if (this.$common.isEmpty(this.$store.state.userInfoList)) return {};
      return this.$store.state.userInfoList;
    },
    // 标识图片
    iconDataList () {
      if (this.$common.isEmpty(this.moduleData) || this.$common.isEmpty(this.moduleData.iconDataList)) return [];
      return this.moduleData.iconDataList;
    },
    // 是否可删除当前模板
    deleteTemplate () {
      if (['manufacturer'].includes(this.tabValue)) return this.permission.deleteManu; // 生产商信息
      // 下面 4 个需求上展示没有，暂时注释
      // if (['ukCompany'].includes(this.tabValue)) return this.permission.deleteBritain; // 英代
      // if (['euCompany'].includes(this.tabValue)) return this.permission.deleteEurope; // 欧代
      // if (['safetyCertificate'].includes(this.tabValue)) return this.permission.deleteIdent; // 标识
      // if (['warning'].includes(this.tabValue)) return this.permission.deleteWarning; // 警告
      return false;
    }
  },
  created() {
    this.pageLoading = true;
    if (!this.$common.isEmpty(this.tabDataList)) {
      let obj = {};
      this.tabDataList.forEach((item, index) => {
        obj = {
          loading: false,
          visible: false,
          tableData: [],
          pageNum: 1,
          pageSize: 20,
          total: 0,
          columns: [...item.columns, ...this.publicCol]
        };
        if (index == 0) {
          this.tabValue = item.key;
          this.activeTabInfo = item;
          this.$set(this.tabPageConfig, item.key, { ...obj, visible: true });
        } else {
          this.$set(this.tabPageConfig, item.key, obj);
        }
      });
    }
  },
  mounted () {
    this.initPage().finally(() => {
      this.pageLoading = false;
      this.$nextTick(() => {
        this.getTableData(this.tabValue);
      })
    });
  },
  methods: {
    // 初始化数据
    initPage () {
      return new Promise((resolve) => {
        let awaitRes = [];
        this.$common.promiseAll(awaitRes).finally(() => {
          resolve({ state: 'end' });
        });
      })
    },
    // 标签页面切换
    tabSwitch (val) {
      if (this.$common.isEmpty(val)) {
        this.activeTabInfo = {};
        return;
      }
      const openInfo = this.tabDataList.find(item => item.key == val);
      if (this.$common.isEmpty(openInfo)) {
        this.activeTabInfo = {};
        return;
      }
      if (val == this.activeTabInfo.key) return;
      this.activeTabInfo = openInfo;
      if (!this.tabPageConfig[val].visible) {
        this.tabPageConfig[val].visible = true;
        this.getTableData(val);
      }
      this.$nextTick(() => {
        this.getTableData(val);
      })
    },
    // 打开新增弹窗
    openAddEditTemplate (row, key) {
      if (this.$common.isEmpty(this.activeTabInfo)) return;
      this.itemModalData = {
        iconDataList: this.iconDataList,
        width: this.activeTabInfo.width,
        row: row,
        key: key,
        title: `${this.$common.isEmpty(row) ? '增加' : '编辑'}${this.activeTabInfo.label}`,
        warTips: this.activeTabInfo.warTips,
      }
      this.$nextTick(() => {
        this.itemModalLoading = false;
        this.itemModalVisible = true;
      });
    },
    // 删除对应模板
    deleteGpsrTemplate (row, key) {
      if (this.$common.isEmpty(this.activeTabInfo) || this.$common.isEmpty(this.activeTabInfo.deleteApi)) return;
      this.$Modal.confirm({
        title: '操作提示',
        okText: '确定',
        content: `<div>你确定要删除：<span style="color: #f20;">${row[this.activeTabInfo.replaceName]}</span>？</div>`,
        onOk: () => {
          let queryObj = {};
          queryObj[this.activeTabInfo.replaceId] = row[this.activeTabInfo.replaceId];
          this.axios.get(this.activeTabInfo.deleteApi, {
            params: queryObj
          }).then(res => {
            if (!res || !res.data || res.data.code != 0) return;
            this.$Message.success('删除成功！');
            this.getTableData(this.activeTabInfo.key);
          })
        }
      });
    },
    // 列表翻页
    pageNumChange (val, key) {
      this.tabPageConfig[key].pageNum = val;
      this.$nextTick(() => {
        this.getTableData(key);
      })
    },
    // 列表条数改变
    pageSizeChange (val, key) {
      this.tabPageConfig[key].pageSize = val;
      this.$nextTick(() => {
        this.getTableData(key);
      })
    },
    // 获取列表数据
    getTableData (key) {
      if (this.$common.isEmpty(key) || this.tabPageConfig[key].loading) return;
      if (this.$common.isEmpty(this.activeTabInfo)) return;
      this.tabPageConfig[key].loading = true;
      this.tabPageConfig[key].tableData = [];
      let queryObj = {
        businessDeptIds: this.businessDeptIdList.join(','),
      };
      Object.keys(this.tabPageConfig[key]).forEach(qKey => {
        if (['pageNum', 'pageSize'].includes(qKey)) {
          queryObj[qKey] = this.tabPageConfig[key][qKey];
        }
      });
      this.axios.post(this.activeTabInfo.listApi, queryObj).then(res => {
        if (res && res.data && res.data.code == 0 && res.data.datas) {
          this.tabPageConfig[key].tableData = res.data.datas.list || [];
          this.tabPageConfig[key].total = res.data.datas.total || 0;
        } else {
          this.tabPageConfig[key].total = 0;
        }
        this.tabPageConfig[key].loading = false;
      }).catch(() => {
        this.tabPageConfig[key].total = 0;
        this.tabPageConfig[key].loading = false;
      });
    },
    // 编辑时保存
    itemModalConfirm () {
      if (this.itemModalLoading) return;
      if (this.$refs.gpsrModalEditRef) {
        this.itemModalLoading = true;
        this.$refs.gpsrModalEditRef.saveFormData({
          saveApi: this.activeTabInfo.saveApi
        }).then((res) => {
          if (res.state != 'success') return;
          this.itemModalVisible = false;
          this.$Message.success('操作成功！');
          this.getTableData(this.activeTabInfo.key);
        }).finally(() => {
          this.itemModalLoading = false;
        })
      }
    }
  }
};
</script>
<style lang="less" scoped>
.gpsr-template-view {
  position: relative;
  .item-warning {
    display: inline-block;
    margin-left: 50px;
    padding: 5px 15px;
    border-radius: 5px;
    color: #fff;
    background: #ff9b00;
  }
  .details-item {
    display: flex;
    margin-bottom: 12px;
    &.item-width-auto{
      .details-label{
        width: auto;
      }
    }
    .details-label{
      width: 150px;
      line-height: 1.2em;
      text-align: right;
      word-wrap: break-word;
      word-break: break-word;
    }
    .details-value {
      padding-left: 5px;
      flex: 100;
      line-height: 1.2em;
      text-align: left;
      word-wrap: break-word;
      word-break: break-word;
    }
  }
  .content-item-head{
    padding: 0 15px;
  }
  :deep(.ivu-tabs){
    .ivu-tabs-bar{
      margin-bottom: 0;
    }
  }
  .sticky-head-block {
    position: sticky;
    top: -16px;
    width: 100%;
    background: #fff;
    z-index: 1000;
  }
  .tab-content{
    .ivu-page{
      text-align: right;
    }
  }
}
</style>
